import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm, Form } from "redux-form";

import PollConfig from "../../utils/PollConfig";
import PollQuestion from "./PollQuestion";
import PollNavigation from "../poll/PollNavigation";
import { nextPollPage } from "../../actions/poll";
import validate from "../../utils/validate";
import { loadState } from "../../utils/poolTools";

const renderPageForm = page => {
  const config = new PollConfig();
  const renderedQuestions = config
    .getQuestions(page)
    .map(question => (
      <PollQuestion key={question.getId()} question={question} />
    ));

  return <div>{renderedQuestions}</div>;
};
const PollForm = props => {
  const pageNum = props.page;

  const { handleSubmit } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <section className="section poll-section">
        <div className="box content is-medium">{renderPageForm(pageNum)}</div>
        <div className="box">
          <PollNavigation page={pageNum} />
        </div>
      </section>
    </Form>
  );
};

PollForm.propTypes = {
  page: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired
};
const config = new PollConfig();

export default reduxForm({
  form: "pollForm",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  touchOnBlur: false,
  touchOnChange: false,
  validate,
  initialValues: loadState("poll-formValues", null, config.initialValues())
})(connect(null, { nextPollPage })(PollForm));



// WEBPACK FOOTER //
// ./src/components/poll/PollForm.js